"use client";

import {isString} from "lodash-es";
import {
	Tooltip,
	TooltipProps,
	TooltipTrigger,
	TooltipTriggerComponentProps,
} from "react-aria-components";
import {twMerge} from "tailwind-merge";

// Using motion-safe might be overkill for this but it can't hurt
const ANIMATION_FADE_UP_SAFE = `
	motion-safe:entering:animate-fade-up motion-safe:exiting:animate-fade-up-reverse
	motion-reduce:entering:animate-fade motion-reduce:exiting:animate-fade-out
`;

interface TooltipWrapperProps extends TooltipTriggerComponentProps {
	tooltip?: string;
	tooltipProps?: Partial<TooltipProps>;
}

const TooltipWrapper: React.FC<TooltipWrapperProps> = ({
	children,
	tooltip,
	tooltipProps = {},
	...props
}) => {
	return (
		<TooltipTrigger delay={0} closeDelay={0} {...props}>
			{children}
			{tooltip && (
				<Tooltip
					{...tooltipProps}
					placement="bottom"
					offset={10}
					className={twMerge(
						"rounded-md bg-lime-rind p-2.5 text-center text-white",
						ANIMATION_FADE_UP_SAFE,
						isString(tooltipProps.className) && tooltipProps.className
					)}
				>
					{tooltip}
				</Tooltip>
			)}
		</TooltipTrigger>
	);
};

export default TooltipWrapper;
